import * as Yup from 'yup';
import { messages } from 'app/config/constants';
export const uploadFilesDefaultValidationSchema = Yup.object({
  files: Yup.array().of(
    Yup.object({
      fileName: Yup.string().required(messages.MANDATORY_FIELD),
    }),
  ),
});
